{
  "name": "astro-cloudinary",
  "version": "1.3.4",
  "type": "module",
  "license": "MIT",
  "module": "./index.ts",
  "keywords": [
    "cloudinary",
    "astro",
    "astro-loader"
  ],
  "exports": {
    ".": {
      "import": "./index.ts"
    },
    "./helpers": {
      "types": "./dist/helpers/index.d.ts",
      "import": "./dist/helpers/index.js"
    },
    "./loaders": {
      "types": "./dist/loaders/index.d.ts",
      "import": "./dist/loaders/index.js"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "dist",
    "helpers",
    "loaders",
    "src",
    "index.ts"
  ],
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "prepublishOnly": "cp ../README.md . && cp ../LICENSE . && pnpm build",
    "postpublish": "rm ./README.md && rm ./LICENSE"
  },
  "dependencies": {
    "@cloudinary-util/types": "1.6.0",
    "@cloudinary-util/url-loader": "6.0.0",
    "@cloudinary-util/util": "^4.1.0",
    "@cloudinary/url-gen": "^1.20.0",
    "@unpic/astro": "^0.0.47",
    "@unpic/core": "^0.0.49",
    "tsup": "^8.4.0",
    "unpic": "^3.18.0"
  },
  "peerDependencies": {
    "astro": "^3.2.0 || ^4.0.0 || ^5.0.0"
  },
  "devDependencies": {
    "astro": "^5.11.0"
  }
}
